import { derivedSelectedRatingsStore } from '#analytics/stores/filters/ratings.js';
import { availableRatingsStore } from '#stores/availables/ratings.js';
import { attributesConfigStore } from '#stores/configs/attributes.js';
import { createTranslationsStore } from '#pagebuilder/lib/helpers/translations.js';

export const translationsStore = createTranslationsStore(attributesConfigStore, availableRatingsStore, derivedSelectedRatingsStore);
